module.exports = __webpack_public_path__ + "img/cosmetique.3b81b7c7.png";